module.exports = __webpack_public_path__ + "img/_Generic8.8393d3c4.jpg";